import { Component,  EventEmitter,  Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Program } from 'globals/store/programs.data';
import { CommonModule } from '@angular/common';
import { ProgramDayDate } from 'src/app/services/pipes/programs.pipe';

@Component({
    selector: 'incrementor',
    template: `
<div class="before">{{ program | programDayDate:(currentValue || 0) + 1:true }}</div>
<div class="secondary_link edit" *ngIf="!editing && !readOnly" (click)="$event.stopPropagation(); editing = true;">Edit</div>
<ng-container *ngIf="!!editing">
  <div class="control left" (click)="decrement()">-</div>
  <div class="value">{{ currentValue }}</div>
  <div class="control right" (click)="increment()">+</div>
  <div class="secondary_link save" (click)="$event.stopPropagation(); save();">Save</div>
  <div class="secondary_link cancel" (click)="$event.stopPropagation(); editing = false; currentValue = value;">Cancel</div>
</ng-container>

`,
    styles: [`
  :host { display: flex; align-items: center; }
  .cancel { margin-left: 5px; }
  .control { display: flex; width: 24px; height: 24px; justify-content: center; border: 1px solid #ccc; border-radius: 6px; cursor: pointer; margin: 0 10px; }
  .edit { margin-left: 5px; }
`],
    standalone: true,
    imports: [CommonModule, ProgramDayDate]
})
export class IncrementorComponent implements OnChanges, OnInit { // was originally meant to be more flexible...
  @Input() value = 0
  // @Input() beforeText: string
  // @Input() afterText: string
  
  @Input() program: Program
  @Input() readOnly: boolean
  @Output() onSave: EventEmitter<number> = new EventEmitter()
  editing = false
  currentValue: number = 0
  
  save() {
    if (this.currentValue !== this.value) this.onSave.emit(this.currentValue)
    this.value = this.currentValue
    this.editing = false
  }

  increment() {
    this.currentValue += 1
  }

  decrement() {
    this.currentValue -= 1
  }

  ngOnInit() {
    this.currentValue = this.value
    // console.log({ currentValue: this.currentValue })
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log({ changes })
    if (changes.value?.currentValue) this.currentValue = changes.value.currentValue
  }

}

